export const ContinueButton = (props) => {
  let text =
    props.stepNumber === 1
      ? "Vybral jsem si set, chci zobrazit slevu"
      : "Sestavit nové produkty";

  let cssClasses = "button button-default";

  if (props.stepNumber === 2) {
    cssClasses = cssClasses + " with-arrow-left";
  } else if (props.stepNumber === 1) {
    cssClasses = cssClasses + " step-one";
  } else if (props.stepNumber === 3) {
    cssClasses = cssClasses + " hidden";
  } else if (props.itemsCount < 2) {
    cssClasses = cssClasses + " disabled";
  }

  let divStyle = { textAlign: "center" };

  if (props.stepNumber === 1) {
    divStyle["marginTop"] = 50;
    divStyle["position"] = "sticky";
    divStyle["bottom"] = 20;
    divStyle["zIndex"] = 21;
    divStyle["backgroundColor"] = "white";
    divStyle["padding"] = 10;
    divStyle["border"] = "1px solid #B7B7B7";
    divStyle["margin"] = "auto";
    divStyle["width"] = "400";
    divStyle["maxWidth"] = "100%";
  }

  if (props.stepNumber === 2) {
    divStyle["float"] = "left";
  }

  var buttonStyle = { fontWeight: "bold", backgroundColor: "#B7B7B7" };

  if (props.stepNumber === 1) {
    $.extend(buttonStyle, {
      fontWeight: "bold",
      fontSize: 19,
      backgroundColor: "#E7C407",
    });
  }

  return (
    <div className="button-border" style={divStyle}>
      <div
        className={cssClasses}
        style={buttonStyle}
        onClick={() => handleClick()}
      >
        {text}
      </div>
      <span>
        {props.itemsCount < 2 ? (
          <em>
            <br />
            Pro vytvoření setu vyberte alespoň 2 spotřebiče
          </em>
        ) : null}
      </span>
    </div>
  );

  function handleClick() {
    let newStep;

    if (props.stepNumber === 1) {
      newStep = 2;
    } else {
      newStep = 1;
    }

    props.stepChange(newStep);
    // props.stickCategorySelection = false;
    if (newStep === 1) {
      props.resetItems();
    }
  }
};
